import type React from "react"

import type { Site } from "@/models/site"

import { Paper } from "@mui/material"

import { SiteInfoContent } from "./siteInfoContent"

interface SiteInfoProps {
  onClose: () => void
  site: Site | null
}

export const SiteInfo: React.FC<SiteInfoProps> = ({ onClose, site }) => (
  <Paper
    elevation={4}
    sx={{
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      height: "100%",
    }}
  >
    <SiteInfoContent onClose={onClose} site={site} />
  </Paper>
)
